"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickCircle = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.TickCircle = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "tick-circle", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M200 0C89.6 0 0 89.6 0 200S89.6 400 200 400S400 310.4 400 200S310.4 0 200 0zM300 280C294.4000000000001 280 289.4000000000001 277.8 285.8 274.2L160 148.2L114.2 194.2C110.6 197.8 105.6 200 100 200C89 200 80 191 80 180C80 174.4 82.2 169.4 85.8 165.8L145.8 105.8C149.4 102.2 154.4 100 160 100C165.6 100 170.6 102.2 174.2 105.8L314.2000000000001 245.8C317.8 249.4 320 254.4 320 260C320 271 311 280 300 280z" : "M160 0C71.6 0 0 71.6 0 160S71.6 320 160 320S320 248.4 320 160S248.4 0 160 0zM240 220C234.4 220 229.4 217.8 225.8 214.2L140 128.2L94.2 174.2C90.6 177.8 85.6 180 80 180C69 180 60 171 60 160C60 154.4 62.2 149.4 65.8 145.8L125.8 85.8C129.4 82.2 134.4 80 140 80S150.6 82.2 154.2 85.8L254.2 185.8C257.8 189.4 260 194.4 260 200C260 211 251 220 240 220z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.TickCircle.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.TickCircle.displayName = "Blueprint5.Icon.TickCircle";
exports.default = exports.TickCircle;
//# sourceMappingURL=tick-circle.js.map